<template>
  <div class="w-full md:w-1/2 pt-[90px] md:pt-[0px]">
    <div
      class="w-[80%] h-[15vh] m-auto flex flex-col justify-end md:h-[25vh] mt-16"
    >
      <div class="m-auto flex justify-center md:h-[25vh] mt-16">
        <img
          src="../assets/AccessLogo.png"
          alt=""
          class="w-30 h-14 p-[1px] rounded object-fill"
        />
      </div>
      <h4 class="text-md font-bold mt-2 text-[#09518C]">Sign Up</h4>
      <p class="text-gray-500 text-sm mt-2">
        An email detailing the log in instruction will be sent to your email
        provided you have an account with us.
      </p>
    </div>
    <div class="w-[80%] h-[70vh] m-auto">
      <div class="pt-[16px]">
        <form @submit.prevent="onResetSubmit" class="">
          <div
            v-if="showResetErrorMsg"
            class="bg-red-600 text-white text-center mb-3 rounded-md py-4"
          >
            <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
            {{ showResetErrorMsg }}
          </div>

          <div
            v-if="showResetSuccessMsg"
            class="bg-green-600 text-white text-center mb-3 rounded-md py-4"
          >
            <font-awesome-icon class="mr-2" icon="fa-exclamation-triangle" />
            {{ showResetSuccessMsg }}
          </div>
          <div class="mb-4 mt-2">
            <p class="block text-[#09518C] text-sm font-bold mb-2">
              Employer Code
            </p>
            <div class="flex">
              <input
                v-model="registerState.code"
                class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="code"
                placeholder="Employer Code"
              />
            </div>
          </div>
          <div
            class="input-errors text-sm text-red-500"
            v-for="error of vv.code?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Employer code is required</div>
          </div>
          <div class="my-4">
            <p class="block text-[#09518C] text-sm font-bold mb-2">
              Contact E-Mail
            </p>
            <div class="flex">
              <input
                type="email"
                v-model="registerState.contact_email"
                class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="contact_email"
                placeholder="Contact E-Mail"
              />
            </div>
          </div>
          <div
            class="input-errors text-sm text-red-500"
            v-for="error of vv.contact_email?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Contact email is required</div>
          </div>
          <div class="my-4">
            <p class="block text-[#09518C] text-sm font-bold mb-2">
              Contact Phone Number
            </p>
            <div class="flex">
              <input
                v-model="registerState.contact_phone"
                class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                formControlName="contact_phone"
                placeholder="Contact Phone Number"
              />
            </div>
          </div>
          <div
            class="input-errors text-sm text-red-500"
            v-for="error of vv.contact_phone?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Contact phone number is required</div>
          </div>

          <div class="flex">
            <label class="flex items-center">
              <input
                v-model="registerState.check"
                class="float-right -mt-5"
                formControlName="status"
                type="checkbox"
              />
              <div class="flex">
                <div
                  class="text-gray-700 text-sm font-bold mb-2 cursor-pointer mt-2 ml-3"
                >
                  By ticking this box, I agree to the collection and processing
                  of my personal data in line with the NDPA and Access
                  Pensions’
                  <span class="text-[#8DC63F] cursor-pointer">
                    <a
                      href="hhttps://accesspensions.ng/wp-content/uploads/2023/08/Data-Protection-and-Privacy-Policy-Signed.pdf"
                      target="_blank"
                      >Data Privacy Policy</a
                    >
                  </span>
                </div>
              </div>
            </label>
          </div>

          <div
            class="input-errors text-sm text-red-500"
            v-for="error of vv.check?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Please tick this box to agree</div>
          </div>

          <div class="my-4">
            <button
              class="text-white rounded-lg w-full py-2 hover:bg-white hover:text-[#F58220] border border-[#8DC63F]"
              :disabled="resetLoading === true"
              :class="resetLoading ? 'bg-gray-500' : 'bg-[#8DC63F]'"
            >
              <div v-if="resetLoading === true">
                <div
                  role="status"
                  class="flex justify-center w-full"
                  v-if="resetLoading === true"
                >
                  <svg
                    class="inline mr-2 w-5 h-5 text-white animate-spin dark:text-gray-600 fill-[#8DC63F]"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-if="resetLoading === false">Submit</div>
            </button>
          </div>

          <div>
            <div class="flex justify-end">
              <small class="font-bold pr-1 text-gray-500">
                Already have an account?
              </small>
              <small
                class="text-[#09518C] font-bold cursor-pointer hover:text-[#F58220]"
                @click="toggleLoginForm(0)"
              >
                Login
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { required, sameAs } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { toolkitAxios } from "@/env";
export default {
  props: {
    toggleLoginForm: Function,
  },
  setup() {
    const showResetErrorMsg = ref(null);
    const showResetSuccessMsg = ref(null);
    const resetLoading = ref(false);

    const registerState = reactive({
      code: "",
      contact_email: "",
      contact_phone: "",
      check: false,
    });

    const resetRules = {
      code: { required },
      contact_email: { required },
      contact_phone: { required },
      check: { sameAs: sameAs(true) },
    };

    const vv = useVuelidate(resetRules, registerState);

    const onResetSubmit = async () => {
      vv.value.$touch();

      if (vv.value.$invalid) return;

      resetLoading.value = true;

      await toolkitAxios
        .post("employer/register", {
          code: registerState.code,
          contact_email: registerState.contact_email,
          contact_phone: registerState.contact_phone,
        })
        .then(() => {
          showResetSuccessMsg.value =
            "Registration is Successful. Please check your email and/or Phone Number for further instructions";
        })
        .catch((error) => {
          showResetErrorMsg.value = error.response.data.message;
        })
        .finally(() => {
          resetLoading.value = false;
        });
    };

    return {
      onResetSubmit,
      vv,
      registerState,
      showResetSuccessMsg,
      showResetErrorMsg,
      resetLoading,
    };
  },
};
</script>

<style></style>
